import React from "react";

interface SubtitlesIconProps {
  className?: string;
}

const SubtitlesIcon: React.FC<SubtitlesIconProps> = ({ className }) => (
  <svg width="22px" height="22px" viewBox="0 0 380 380">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(15.000000, 15.000000)">
        <rect stroke="#818181" strokeWidth="30" x="0" y="0" width="350" height="350" rx="45" />
        <rect fill="#818181" x="53" y="193" width="73" height="31.3902439" rx="15.695122" />
        <rect fill="#818181" x="225" y="255.609756" width="73" height="31.3902439" rx="15.695122" />
        <rect fill="#818181" x="156" y="193" width="142" height="31.3902439" rx="15.695122" />
        <rect fill="#818181" x="53" y="255.609756" width="142" height="31.3902439" rx="15.695122" />
      </g>
    </g>
  </svg>
);

export default SubtitlesIcon;
